module.exports = __webpack_public_path__ + "static/media/19-years-of-excellence-logo.52f0ff31.png";